import "./corporate-zal-card";
